import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';

import { ModalService } from 'app/shared/modal/modal.service';

@Component({
  selector: 'campus-turno',
  templateUrl: './campus-turno.component.html',
  styleUrls: ['./campus-turno.component.scss'],
})
export class CampusTurnoComponent implements OnChanges {
  @Input() curso: any = {};
  @Input() cidade: any = {};
  @Input() opcoesCampusTurno: any[] = [];
  @Input() deveMostrarLegenda = false;
  @Input() legendasDescontos: any[] = [];
  @Input() responsive = true;
  @Input() campusTurnoSelecionado: any = {};
  @Input() resultCampusTurno: any[] = [];

  @Output() aoSelecionarOpcao = new EventEmitter<any>();

  campusTurnoInfo: any = {};
  integral = false;
  textoSelecaoPlaceholder: String = 'Escolha campus e turno';
  tipo: String = 'presencial';
  turnos = ['matutino', 'vespertino', 'noturno'];
  routerSubscription: Subscription;
  path: any;
  environment = environment;
  cursosDesconto30 = ['0001','0021','0075','0003','0006','0027','0049','0067','0089','0051','0091','0092','0077','0015','0013','0028','0078','0074','0046','0019','0053','0020','0022','0050','0023','0043','0005'];
  valorCurso:any;
  valorDesconto:any;
  descricaoValorDesconto:any;
  exibirWeb:any;
  marketPlaceData: any;


  constructor(private modalService: ModalService,
    private router: Router) {
    this.routerSubscription = this.router.events
    .filter((event) => event instanceof NavigationEnd)
    .subscribe((evento) => {

      if (evento instanceof NavigationEnd) {
        //console.log(evento);
        this.path = evento.url.split("/");
        //console.log(this.path);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.valorCurso = null;
    this.valorDesconto = null;
    this.descricaoValorDesconto = null;
    this.exibirWeb = null;
    const { curso, cidade, opcoesCampusTurno, campusTurnoSelecionado } = changes;


    
    this.getMarketPlaceData();

    if(this.marketPlaceData != null){
        this.tratarMudancaValor();
    }
    


    //console.log(changes);
    this.tipo = 'presencial';
    if (curso && curso.currentValue && curso.currentValue.presencial) {
      if (curso.currentValue.presencial === 'N') {
        //console.log(curso);
        this.tipo = 'ead';
        this.textoSelecaoPlaceholder = 'Escolha o polo de apoio presencial';
      }
    }

    if (curso || cidade) {
      this.campusTurnoSelecionado = {};
      this.campusTurnoInfo = {};
    }

    if (campusTurnoSelecionado &&
       campusTurnoSelecionado.currentValue &&
       campusTurnoSelecionado.currentValue.campus &&
       campusTurnoSelecionado.currentValue.turno) {
      this.campusTurnoSelecionado = campusTurnoSelecionado.currentValue;
      this.campusTurnoInfo = this.campusTurnoSelecionado.campus[this.campusTurnoSelecionado.turno];
    }


    if (opcoesCampusTurno && opcoesCampusTurno.currentValue && opcoesCampusTurno.currentValue.length) {
      this.integral = opcoesCampusTurno.currentValue.some(opcao => opcao.integral);
      if (opcoesCampusTurno.currentValue.length === 1) {
        const turnos = [...this.turnos, 'integral'].filter(turno => opcoesCampusTurno.currentValue[0][turno]);
        //console.log(turnos);
        if (turnos.length === 1) {
          this.campusTurnoSelecionado = { campus: opcoesCampusTurno.currentValue[0], turno: turnos[0] };
          //console.log(this.campusTurnoSelecionado);
          this.tratarMudancaValor();
        }
      }
    }
  }

  getValorFinal(opcaoCampus: any, turno: string): number {
    if (opcaoCampus[turno] === null) {
      return null;
    }
    return this.calcValorFinal(this.curso, opcaoCampus[turno]);
  }

  calcValorFinal(curso, campusTurno): number {
    let preco = curso.valorBase;
    if (campusTurno.desconto) {
      preco *= (1 - (campusTurno.desconto / 100));
    }
    return preco;
  }

  isClickable(opcaoCampus: any, turno: string): boolean {
    return opcaoCampus[turno] !== null;
  }

  isSelected(opcaoCampus: any, turno: string): boolean {
    return this.campusTurnoSelecionado.campus
      && this.campusTurnoSelecionado.turno
      && this.campusTurnoSelecionado.campus.id === opcaoCampus.id
      && this.campusTurnoSelecionado.turno === turno;
  }

  getLegenda(opcaoCampus: any, turno: string): string {
    if (opcaoCampus[turno] === null) {
      return null;
    }
    return opcaoCampus[turno].legendaDesconto;
  }

  getLegendaDescontoSelecionada() {
    return this.campusTurnoInfo ? this.campusTurnoInfo.legendaDesconto : undefined;
  }

  tratarMudancaValor() {
    if(this.marketPlaceData != null){
      this.opcoesCampusTurno.forEach((cursoTurno) =>{
        if(cursoTurno['id'] == this.marketPlaceData['campus']['id']){
          this.campusTurnoSelecionado['campus'] = cursoTurno;
          switch (this.marketPlaceData['turno']) {
            case 'M':
              this.campusTurnoSelecionado['turno'] = 'matutino'
              break;
            case 'V':
              this.campusTurnoSelecionado['turno'] = 'vespertino'
              break;
            case 'N':
              this.campusTurnoSelecionado['turno'] = 'noturno'
              break;
            case 'I':
              this.campusTurnoSelecionado['turno'] = 'integral'
              break;
          
            default:
              break;
          }
  
          this.aoSelecionarOpcao.emit({ campusTurno: this.campusTurnoSelecionado, campusTurnoInfo: this.campusTurnoInfo });
        }
  
      });
    }

    if (!this.curso || !this.campusTurnoSelecionado) {
      return;
    }
    this.campusTurnoInfo = this.campusTurnoSelecionado.campus[this.campusTurnoSelecionado.turno];
    this.aoSelecionarOpcao.emit({ campusTurno: this.campusTurnoSelecionado, campusTurnoInfo: this.campusTurnoInfo });
    //console.log(this.resultCampusTurno);
    let curso = this.resultCampusTurno.filter((curso)=>{
      return curso.id === this.curso.id;
    })
    let campus = curso[0].campi.filter((campi)=>{
      return campi.id === this.campusTurnoSelecionado.campus.id;
    })
    //console.log(campus);
    if(campus[0]!=undefined){
      let turno = campus[0].turnos.filter((turnos)=>{
        return turnos.turno === this.campusTurnoSelecionado.turno.substring(0,1).toUpperCase();
      })
      this.valorCurso = turno[0].valorCurso;
      this.valorDesconto = turno[0].valorCursoDesconto;
      this.descricaoValorDesconto = turno[0].descricaoValorCurso;
      this.exibirWeb = (turno[0].exibirWeb=='S')?turno[0].exibirWeb:undefined;
      //console.log(turno[0]);
      sessionStorage.setItem("valorCurso",turno[0].valorCurso);
    }else{
      this.valorCurso = undefined;
      this.valorDesconto = undefined;
      this.descricaoValorDesconto = undefined;
      this.exibirWeb = undefined;
    }
    //console.log(turno);
  }

  getAnoAtual() {
    return new Date().getFullYear();
  }

  mostrarModalCampusTurnoMobile(): void {
    if (this.cidade && this.curso) {
      this.modalService.open('campusTurnoMobile');
    }
  }


  getMarketPlaceData(){
    this.marketPlaceData = JSON.parse(sessionStorage.getItem("marketPlaceData")); 
  }

  fecharModal() { }
}
